import {each} from 'lodash';
import {x, x0} from '../_helpers';

export default class Accordion {

    constructor(callback) {
        this.elemets = x('[js-trigger]');
        this.callback = callback;
        this.init();
    }

    init() {
        each(this.elemets, el => {
            el.addEventListener('click', () => {
                x0('#'+el.getAttribute('js-trigger')).classList.toggle('-active');
                setTimeout(() => {
                    this.callback && this.callback(el);
                }, 200);
            });
        });
    }
}